import axios from "axios";
import "./CheckSubDomain.css";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import LoginImage from "../../images/login/lg-img.png";
import LoginImageMobile from "../../images/login/lg-img-mob.png";
import { decodeData, encodeURL } from "../../helpers/encrypt";
import { getBrandLogo, getBrandLogoAlt } from "../../utils/brandLogo";

const CheckSubDomain = () => {
  const navigate = useNavigate();
  const { email: encodedEmail } = useParams();
  const [teams, setTeams] = useState([]);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [loadingSubDomain, setLoadingSubDomain] = useState(null);
  const [navigating, setNavigating] = useState(false);
  const [navigatingUrl, setNavigatingUrl] = useState(null);
  const domainName = process.env.REACT_APP_BASE_DOMAIN || window.location.hostname;

  const handleLinkClick = (e, subDomain) => {
    e.preventDefault();
    const url = `https://${subDomain}.${domainName}/login`;
    setLoadingSubDomain(subDomain);
    setNavigatingUrl(url);
    setNavigating(true);
  };

  useEffect(() => {
    if (navigating && navigatingUrl) {
      const timer = setTimeout(() => {
        window.location.href = navigatingUrl;
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [navigating, navigatingUrl]);

  useEffect(() => {
    const getTeam = async () => {
      let deCodedEmail;
      try {
        deCodedEmail = decodeData(encodedEmail);
      } catch (e) {
        navigate("/", { replace: true });
        return;
      }

      try {
        setLoadingTeams(true);
        const res = await axios.get(`/api/tenent/teams/${encodeURL(deCodedEmail)}`);
        const data = res.data;

        if (!data || data.length === 0) {
          navigate("/", { replace: true });
          toast.error("No teams found for this email.", {
            position: "bottom-right",
            autoClose: 2000,
          });
          return;
        }

        setTeams(data);
      } catch (error) {
        navigate("/", { replace: true });
        toast.error("Failed to load teams. Please try again.", {
          position: "bottom-right",
          autoClose: 2000,
        });
      } finally {
        setLoadingTeams(false);
      }
    };

    getTeam();
  }, [encodedEmail]);

  useEffect(() => {
    if (teams.length === 1) {
      const singleTeam = teams[0];
      setLoadingSubDomain(singleTeam.subDomain);
      setNavigatingUrl(`https://${singleTeam.subDomain}.${domainName}/login`);
      setNavigating(true);
    }
  }, [teams, domainName]);

  return (
    <>
      {navigating && (
        <div className="nav-transition-overlay">
          <img src={getBrandLogo()} alt={getBrandLogoAlt()} className="nav-transition-logo" />
          <ThreeDots
            height="50"
            width="50"
            radius="9"
            color="#6479F8"
            ariaLabel="navigating"
            visible={true}
          />
        </div>
      )}
      <div className="login-outer-forget check-email">
        <div className="login-inner">
          <div className="top-logo-mobile">
            <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
          </div>
          <div className="lg-lft">
            <img src={LoginImage} alt="desktop" className="desktop-lg-img" fetchpriority="high" />
            <img
              src={LoginImageMobile}
              alt="mobile"
              className="mobile-lg-img"
            />
          </div>
          <div className="lg-rgt">
            <div className="top-logo">
              <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
            </div>
            <div className="login-form-sec">
              <div>
                <h3>Please confirm the team workspace.</h3>
                <div className="form-outer">

                  <div className="form-outer">
                    <label>Choose your team URL</label>

                    {loadingTeams ? (
                      <div className="loading-teams">
                        <ThreeDots
                          height="60"
                          width="60"
                          radius="9"
                          color="blue"
                          ariaLabel="loading-teams"
                          visible={true}
                        />

                      </div>
                    ) : (
                      teams.length > 0 &&
                      teams.map((item) => (
                        <a
                          key={item.subDomain}
                          className="button-link"
                          href={`https://${item.subDomain}.${domainName}/login`}
                          onClick={(e) => handleLinkClick(e, item.subDomain)}
                        >
                          {loadingSubDomain === item.subDomain ? (
                            <ThreeDots
                              height="38"
                              width="40"
                              radius="9"
                              color="white"
                              ariaLabel="three-dots-loading"
                              visible={true}
                            />
                          ) : (
                            `${item.subDomain}.${domainName}`
                          )}
                        </a>
                      ))
                    )}

                  </div>

                </div>
                <div className="reset-button"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckSubDomain;